import React, { useState, useRef } from 'react';
import PersonalData from './PersonalData/PersonalData';
import CompanyData from './CompanyData/CompanyData';
import SOpaymentData from './S.OPaymentData/SOPaymentData';
import FinishData from './FinsishData/FinishData';
import { motion } from 'framer-motion';
import { RegisterUser, verifyCompanyDetailsService, verifyPersonaDetailsService } from '../../../services/apiService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import Seo from '../../../components/SeoComponent/Seo';
import Loader from '../../../components/Loader/Loader';
import PopMenu from '../../../components/Dialog/PopMenu';

const ApiAccount = () => {
    const stepperRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [userid, setuserId] = useState('');
    const [password, setPassword] = useState('');
    const [pin, setPin] = useState('');
    const [formData, setFormData] = useState({
        user: {
            name: '',
            email_address: '',
            mobile_number: '',
            password: '',
            pin: '',
            pin_code: '',
            landmark_address: '',
            post_office: '',
            district: '',
            state: '',
            dob: '',
            aadhar_number: '',
            pan_number: '',
            pan_image: '',
            aadhar_image: '',
            image: ''

        },
        company: {
            company_name: '',
            company_address: '',
            company_cin: '',
            company_gst_no: '',
            company_pan: '',
            authorized_person_name: '',
            company_type_name: '',
            company_cin_photo: '',
            company_gst_photo: '',
            company_pan_photo: ''
        },
        payment: {
            user_id: '',
            payment_type: '',
            utr: '',
            amount: '',
            status_id: '1'
        }
    });
    const [isInvalid, setIsInvalid] = useState(false);
    const [verificationError, setverificationError] = useState()
    const handleInputChange = (section, field, value) => {
        setFormData(prevState => ({
            ...prevState,
            [section]: {
                ...prevState[section],
                [field]: value
            }
        }));
    };

    const handleSubmit = async () => {
        setIsLoading(true)
        // e.preventDefault();
        try {
            // const response = await axios.post('https://javabackend.idspay.in/api/v1/admin/register/customer', formData);
            const registraionForm = new FormData();
            registraionForm.append('company_cin_photo', formData.company.company_cin_photo);
            registraionForm.append('company_gst_photo', formData.company.company_gst_photo);
            registraionForm.append('company_pan_photo', formData.company.company_pan_photo);
            registraionForm.append("pan_image", formData.user.pan_image);
            registraionForm.append("aadhar_image", formData.user.aadhar_image);
            registraionForm.append("image", formData.user.image);
            const response = await RegisterUser({
                formData: formData,
                comapnyGstImage: registraionForm.get('company_gst_photo'),
                companyCinImage: registraionForm.get('company_cin_photo'),
                companyPanImage: registraionForm.get('company_pan_photo'),
                userPanImage: registraionForm.get('pan_image'),
                userAadharImage: registraionForm.get('aadhar_image'),
                userImage: registraionForm.get('image')
            })

            if (response?.success === true) {
                setIsLoading(false)
                setPassword(response.password);
                setPin(response.pin);
                setuserId(response.user_id)
                showSuccessToast("Successfully added data");
                Next();
                return
            }
            setIsLoading(false)
            showErrorToast(response?.message)
        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    async function Next1() {
        setIsLoading(true);
        const payload = {
            "company": {
                "company_name": formData?.company.company_name,
                "company_address": formData?.company.company_address,
                "company_cin": formData?.company.company_cin,
                "company_gst_no": formData?.company.company_gst_no,
                "company_pan": formData?.company.company_pan,
                "authorized_person_name": formData?.company.authorized_person_name,
                "company_type_name": formData?.company.company_type_name,
            }
        }
        const response = await verifyCompanyDetailsService(payload);

        if (response.status === 422) {
            setIsLoading(false);
            setIsInvalid(true)
            setverificationError(Object.values(response.data.errors).flat());
            return
        }
        showSuccessToast("Details validated successfully")
        setIsLoading(false)
        setIsInvalid(false)
        stepperRef.current.nextCallback()
    }
    async function Next2() {
        setIsLoading(true);
        const payload = {
            "user": {
                "name": formData?.user.name,
                "email_address": formData?.user.email_address,
                "mobile_number": formData?.user.mobile_number,
                "password": formData?.user.password,
                "pin": formData?.user.pin,
                "pin_code": formData?.user.pin_code,
                "landmark_address": formData?.user.landmark_address,
                "post_office": formData?.user.post_office,
                "district": formData?.user.district,
                "state": formData?.user.state,
                "dob": formData?.user.dob,
                "aadhar_number": formData?.user.aadhar_number,
                "pan_number": formData?.user.pan_number,
                "package_id": 1
            }
        }
        const response = await verifyPersonaDetailsService(payload);

        if (response.status === 422) {
            setIsLoading(false);
            setIsInvalid(true)
            setverificationError(Object.values(response.data.errors).flat());
            return
        }
        showSuccessToast("Details validated successfully")
        setIsLoading(false)
        setIsInvalid(false)
        stepperRef.current.nextCallback()
    }
    function Next() {
        stepperRef.current.nextCallback()
    }

    function Prev() {
        stepperRef.current.prevCallback()
    }

    return (
        <>
            <Seo />
            <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2 }}
            >

                {isLoading && <Loader />}
                <PopMenu visible={isInvalid} onClose={() => setIsInvalid(false)} className={'!z-50 h-1/2 !bg-red-100 !text-red-600'}  >


                    <div className='text-red-500 '>
                        {
                            verificationError && verificationError.map((i) => (
                                <p className='font-bold my-2 text-center'>{i}</p>
                            ))
                        }

                    </div>
                </PopMenu>

                <div className="card flex flex-col justify-center md:mt-8 px-4 sm:px-6 lg:px-8 bg-white">


                    <Stepper ref={stepperRef} className="w-full max-w-full md:mt-16 md:mb-64 border-2 p-2 border-blue-500 rounded-md shadow-xl shadow-blue-800" >
                        <StepperPanel header="Company"  >
                            <CompanyData handleInputChange={handleInputChange} Next={Next1} />

                        </StepperPanel>

                        <StepperPanel header="Personal">
                            <PersonalData handleInputChange={handleInputChange} Next={Next2} Prev={Prev} />

                        </StepperPanel>

                        <StepperPanel header="S.O & Payment">
                            <SOpaymentData handleInputChange={handleInputChange} handleSubmit={handleSubmit} Next={Next} Prev={Prev} />

                        </StepperPanel>

                        <StepperPanel header="Finish">
                            <FinishData pin={pin} password={password} userId={userid} Next={Next} Prev={Prev} />

                        </StepperPanel>
                    </Stepper>
                </div>


            </motion.div>

        </ >
    );
};

export default ApiAccount;